import { RegiaoModel } from './../../model/endereco/regiao.model';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RegiaoService {

  emitirRegiaoCriada = new EventEmitter<RegiaoModel>();

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient:HttpClient) { }

  getRegioes(): Observable<ResponsePageable>{
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-regiao', this.httpOptions);
  }

  getPageRegioes(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-regiao?page=${page}&size=${size}`, this.httpOptions);
  }

  postRegiao(regiao: RegiaoModel): Observable<RegiaoModel>{
    this.emitirRegiaoCriada.emit(regiao);
    return this.httpClient.post<RegiaoModel>(this.apiURL + '/new/adicionar-regiao', regiao, this.httpOptions);
  }

  putRegiao(regiao: RegiaoModel): Observable<RegiaoModel>{
    return this.httpClient.put<RegiaoModel>(this.apiURL + '/edit/editar-regiao', regiao, this.httpOptions);
  }

  deleteRegiao(id: any) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + '/delete/apagar-regiao/' + id, { headers, responseType: 'text' });
  }



}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/regiao.service.ts